import type { SaveData } from "@/types";
import type { StorageService } from "./StorageService";

export const SAVE_KEY = "game.autosave";

export class SaveManager {
  constructor(
    private readonly storage: StorageService,
    private readonly key: string = SAVE_KEY
  ) {}

  async save(data: SaveData): Promise<void> {
    await this.storage.set<SaveData>(this.key, data);
  }

  async load(): Promise<SaveData | null> {
    const data = await this.storage.get<SaveData>(this.key);
    if (!data) return null;
    if (data.version !== 1) {
      console.warn("[save] unsupported save version", data.version);
      return null;
    }
    return data;
  }

  async hasSave(): Promise<boolean> {
    return (await this.storage.get<SaveData>(this.key)) !== null;
  }

  async deleteSave(): Promise<void> {
    await this.storage.remove(this.key);
  }
}

export function saveKeyFor(storyId: string): string {
  return `${SAVE_KEY}.${storyId}`;
}
